// src/components/Navbar.js
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import LanguageDropdown from "./LanguageDropdown";
import "./Navbar.css";
import logo from "../assets/logo.svg";
import { useTranslation } from "react-i18next";

function Navbar() {
	const { t } = useTranslation();
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const navbarRef = useRef(null);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (navbarRef.current && !navbarRef.current.contains(event.target)) {
				setIsMenuOpen(false);
			}
		};

		if (isMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isMenuOpen]);

	return (
		<header className="navbar">
			<div className="navbar-logo">
				<img src={logo} alt="Sun Medical Logo" />
			</div>
			<button className="menu-button" onClick={toggleMenu}>
				☰
			</button>
			<nav
				ref={navbarRef}
				className={`navbar-links ${isMenuOpen ? "open" : ""}`}
			>
				<Link to="/#Surrogate" onClick={() => setIsMenuOpen(false)}>
					{t("navSur")}
				</Link>
				<Link to="/#IVF" onClick={() => setIsMenuOpen(false)}>
					{t("navIVF")}
				</Link>
				<Link to="/#Services" onClick={() => setIsMenuOpen(false)}>
					{t("navServices")}
				</Link>
				<Link to="/#FAQ" onClick={() => setIsMenuOpen(false)}>
					{t("navFAQ")}
				</Link>
			</nav>
			<LanguageDropdown />
		</header>
	);
}

export default Navbar;
